import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import Index from "./pages/Index";
import VagasPage from "./pages/VagasPage";
import VagaDetailPage from "./pages/VagaDetailPage";
import EmpresasPage from "./pages/EmpresasPage";
import EmpresaVagasPublicPage from "./pages/EmpresaVagasPublicPage";
import CandidatoMinhaContaPage from "./pages/CandidatoMinhaContaPage";
import CandidatoVagasSalvasPage from "./pages/CandidatoVagasSalvasPage";
import EmpresaDashboardPage from "./pages/EmpresaDashboardPage";
import EmpresaCriarVagaPage from "./pages/EmpresaCriarVagaPage";
import EmpresaEditarVagaPage from "./pages/EmpresaEditarVagaPage";
import EmpresaVagaPerguntasPage from "./pages/EmpresaVagaPerguntasPage";
import EmpresaVagaCandidatosPage from "./pages/EmpresaVagaCandidatosPage";
import EmpresaBancoTalentosPage from "./pages/EmpresaBancoTalentosPage";
import EmpresaMinhaContaPage from "./pages/EmpresaMinhaContaPage";
import AuthConfirmPage from "./pages/AuthConfirmPage";
import LoginPage from "./pages/LoginPage";
import DicasPage from "./pages/DicasPage";
import PlanosPage from "./pages/PlanosPage";
import ContatoPage from "./pages/ContatoPage";
import PrivacidadePage from "./pages/PrivacidadePage";
import TermosPage from "./pages/TermosPage";
import SobrePage from "./pages/SobrePage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import FaqPage from "./pages/FaqPage";
import PagamentoResultadoPage from "./pages/PagamentoResultadoPage";
import NotFound from "./pages/NotFound";
import { CandidateOnlyRoute } from "./components/CandidateOnlyRoute";
import { CompanyOrGuestRoute } from "./components/CompanyOrGuestRoute";
import { ScrollToTop } from "./components/ScrollToTop";

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="theme">
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Rotas de confirmação de email - públicas */}
          <Route path="/auth/confirm" element={<AuthConfirmPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          
          {/* Rotas exclusivas para candidatos - empresas são redirecionadas */}
          <Route path="/" element={
            <CandidateOnlyRoute>
              <Index />
            </CandidateOnlyRoute>
          } />
          <Route path="/vagas" element={
            <CandidateOnlyRoute>
              <VagasPage />
            </CandidateOnlyRoute>
          } />
          <Route path="/vagas/:id" element={
            <CandidateOnlyRoute>
              <VagaDetailPage />
            </CandidateOnlyRoute>
          } />
          <Route path="/empresas" element={
            <CandidateOnlyRoute>
              <EmpresasPage />
            </CandidateOnlyRoute>
          } />
          <Route path="/empresas/:companyId/vagas" element={
            <CandidateOnlyRoute>
              <EmpresaVagasPublicPage />
            </CandidateOnlyRoute>
          } />
          <Route path="/candidato/minha-conta" element={
            <CandidateOnlyRoute>
              <CandidatoMinhaContaPage />
            </CandidateOnlyRoute>
          } />
          <Route path="/candidato/vagas-salvas" element={
            <CandidateOnlyRoute>
              <CandidatoVagasSalvasPage />
            </CandidateOnlyRoute>
          } />
          
          {/* Rota de login unificada */}
          <Route path="/entrar" element={<LoginPage />} />
          
          {/* Rotas de empresa - acessíveis apenas para empresas/recrutadores */}
          <Route path="/empresa/dashboard" element={<EmpresaDashboardPage />} />
          <Route path="/empresa/banco-talentos" element={<EmpresaBancoTalentosPage />} />
          <Route path="/empresa/criar-vaga" element={<EmpresaCriarVagaPage />} />
          <Route path="/empresa/vaga/:jobId/editar" element={<EmpresaEditarVagaPage />} />
          <Route path="/empresa/vaga/:jobId/perguntas" element={<EmpresaVagaPerguntasPage />} />
          <Route path="/empresa/vaga/:jobId/candidatos" element={<EmpresaVagaCandidatosPage />} />
          <Route path="/empresa/minha-conta" element={<EmpresaMinhaContaPage />} />
          
          {/* Rotas públicas - acessíveis por todos */}
          <Route path="/dicas" element={<DicasPage />} />
          <Route path="/planos" element={
            <CompanyOrGuestRoute>
              <PlanosPage />
            </CompanyOrGuestRoute>
          } />
          <Route path="/contato" element={<ContatoPage />} />
          <Route path="/sobre" element={<SobrePage />} />
          <Route path="/privacidade" element={<PrivacidadePage />} />
          <Route path="/termos" element={<TermosPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/pagamento-resultado" element={<PagamentoResultadoPage />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
